module.exports = __webpack_public_path__ + "static/media/Airbnb.74ef1266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registryOnboard/logos/Airbnb.png
// module id = 2022
// module chunks = 51